module.exports = __webpack_public_path__ + "media/images/bg-started-contents-92b05259.png";